import {
  getClientFacingMessage,
  isBookingProviderUnavailableError,
  isBookingProviderUncertainError,
  isProviderUnavailableError,
} from '@massilia/queries'

export type ReservationErrorType = 'error' | 'maintenance' | 'uncertain'

const FALLBACK_MESSAGE =
  "Votre réservation n'a pas pu être enregistrée. Aucun montant n'a été débité et votre sélection est conservée."

/**
 * Classe l'échec de l'enregistrement de la réservation. Le message affiché est
 * celui de l'API quand il est exploitable — il est déjà rédigé pour le client —,
 * jamais un texte technique remonté d'un 500.
 */
/** Un échec d'enregistrement classé, avec le texte à montrer au client. */
export interface ReservationError {
  message: string
  type: ReservationErrorType
}

export function toReservationError(error: Error): ReservationError {
  const message = getClientFacingMessage(error, FALLBACK_MESSAGE)

  if (isBookingProviderUncertainError(error)) {
    return { message, type: 'uncertain' }
  }

  if (isBookingProviderUnavailableError(error) || isProviderUnavailableError(error)) {
    return { message, type: 'maintenance' }
  }

  return { message, type: 'error' }
}
